<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :ripple="false" icon>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="$router.push('/service-providers/' + serviceProvider.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye-outline </v-icon>
        <span class="body-2">{{ $t('forms.visualize') }}</span>
      </v-list-item>
      <v-list-item @click="edit(serviceProvider.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-pencil-outline </v-icon>
        <span class="body-2">{{ $t('forms.update') }}</span>
      </v-list-item>
      <v-list-item @click="remove(serviceProvider.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-delete-outline </v-icon>
        <span class="body-2">{{ $t('forms.delete') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ServiceProviderListMenu',

  props: {
    serviceProvider: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions(['handleOpenCreateUpdateServiceProviderModal', 'handleOpenDeleteServiceProviderModal']),

    edit(id) {
      this.handleOpenCreateUpdateServiceProviderModal(id)
    },

    remove(id) {
      this.handleOpenDeleteServiceProviderModal(id)
    },
  }
}
</script>
